import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "translate-container"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "mobile"
}
const _hoisted_4 = { class: "translate-menu" }
const _hoisted_5 = { class: "head" }
const _hoisted_6 = { class: "body" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "actions" }
const _hoisted_10 = {
  key: 1,
  class: "desktop"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Overlay = _resolveComponent("Overlay")!

  return (_ctx.showTranslations)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["toggle-button", { open: _ctx.languageSelectorActive }])
        }, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleLanguageSelector && _ctx.toggleLanguageSelector(...args))),
            class: "caption"
          }, [
            _createElementVNode("img", {
              src: _ctx.activeLanguage.img,
              alt: ""
            }, null, 8, _hoisted_2),
            _createTextVNode(" " + _toDisplayString(_ctx.activeLanguage.name), 1)
          ])
        ], 2),
        (_ctx.languageSelectorActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_Overlay, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("h3", null, [
                        _createVNode(_component_TranslatedText, { path: "language.select" })
                      ]),
                      _createElementVNode("p", null, [
                        _createVNode(_component_TranslatedText, { path: "language.desc" })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (lang) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: lang.key
                          }, [
                            _createElementVNode("button", {
                              class: _normalizeClass({ active: lang.key === _ctx.currentLanguage }),
                              onClick: ($event: any) => (_ctx.selectLanguage(lang.key))
                            }, [
                              (lang.img)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: lang.img,
                                    class: "flag"
                                  }, null, 8, _hoisted_8))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(lang.name), 1)
                            ], 10, _hoisted_7)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_Button, {
                        text: "common.save-preference",
                        customClass: "full-width",
                        "is-block": "",
                        onClick: _ctx.save
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_Button, {
                        text: "common.cancel-action",
                        customClass: "full-width",
                        variant: "secondary",
                        "is-block": "",
                        onClick: _ctx.cancel
                      }, null, 8, ["onClick"])
                    ])
                  ])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.languageSelectorActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "triangle" }, null, -1)),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (lang) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: lang.key
                  }, [
                    _createElementVNode("button", {
                      class: _normalizeClass({ active: _ctx.currentLanguage === lang.key }),
                      onClick: ($event: any) => (_ctx.selectLanguage(lang.key))
                    }, [
                      (lang.img)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: lang.img,
                            class: "flag"
                          }, null, 8, _hoisted_12))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(lang.name), 1)
                    ], 10, _hoisted_11)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}